import Flex from 'components/common/Flex';
import IconButton from 'components/common/IconButton';
import React from 'react';
import { Card, Dropdown } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

const ContactDetailsHeader = ({ handleShow, handleAddNote }) => {
  const navigate = useNavigate();
  return (
    <Card className="mb-3">
      <Card.Header className="d-flex flex-between-center">
        <IconButton
          onClick={() => navigate('/alumnos/lista-2025')}
          variant="falcon-default"
          size="sm"
          icon="arrow-left"
        />
        <Flex>
          <IconButton
            onClick={handleShow}
            variant="falcon-default"
            size="sm"
            icon="tasks"
            transform="shrink-2"
            iconAlign="middle"
            className="d-xl-none"
          />
          <IconButton
            onClick={handleAddNote}
            variant="falcon-default"
            size="sm"
            icon="plus"
            transform="shrink-2"
            iconAlign="middle"
            className="ms-2"
          />
          <Dropdown align="end" className="btn-reveal-trigger d-inline-block">
          </Dropdown>
        </Flex>
      </Card.Header>
    </Card>
  );
};

ContactDetailsHeader.propTypes = {
  handleShow: PropTypes.func,
  handleAddNote: PropTypes.func 
};

export default ContactDetailsHeader;
